import { combineReducers } from 'redux';
import { createResponsiveStateReducer } from 'redux-responsive';

import sidebar from './sidebarReducer';
import tripsTrailheads from './tripsTrailheadsReducer';
import legend from './legendReducer';
import distanceReadout from './distanceReadoutReducer';

// breakpoints
const browser = createResponsiveStateReducer({
  extraSmall: 420,
  small: 550,
  medium: 750,
  large: 1000,
  extraLarge: 1200
}, {
  extraFields: () => ({
    width: window.innerWidth,
    height: window.innerHeight
  })
});


export default combineReducers({
  browser,
  distanceReadout,
  legend,
  sidebar,
  tripsTrailheads,
});

export { defaultTripsTrailheadsState } from './tripsTrailheadsReducer';



// WEBPACK FOOTER //
// ./map/reducers/index.js